import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MenuSection from './MenuSection';
import MenuPage from './MenuPage';
import './styles.styl';

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMenu: '',
      allPathsOn: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    let currentTitle = '';

    nextProps.data.map(data_chunk => {
      if (data_chunk.children && data_chunk.children.length > 0) {
        data_chunk.children.map(page => {
          if (page.path === nextProps.currentPage) {
            return (currentTitle = data_chunk.title);
          }
          return currentTitle;
        });
      }
      return currentTitle;
    });
    this.setState({
      openMenu: currentTitle
    });
  }

  toggleSidebar = () => {
    this.props.setSidebarToggled(!this.props.sidebarToggled);
  };

  setOpenMenu = title => {
    if (this.state.openMenu === title) {
      this.setState({
        openMenu: ''
      });
    } else {
      this.setState({
        openMenu: title
      });
    }
  };

  onMenuFocus = () => {
    // if the user arrives inside the nav menu without toggling the sidebar, e.g. by jumping to the navigation region,
    // auto-expand the sidebar.

    if (!this.props.sidebarToggled) {
      this.toggleSidebar();
    }

    // TODO: it is currently not possible to focus on the nav menu if the sidebar is not toggled. Investigate how this
    // affects screen readers / other AT that might want to jump to <nav>s
  };

  turnRoutesOn = () => {
    this.setState({
      allPathsOn: !this.state.allPathsOn
    });
  };

  determineLastSection = index => {
    return index === this.props.data.length - 1;
  };

  render() {
    const { openMenu, allPathsOn } = this.state;
    const { metaData, data, currentPage } = this.props;

    return (
      <div className="menu" onFocus={this.onMenuFocus}>
        <div className="menu-header">
          <Link to="/">{metaData.menu.logo}</Link>
          <div className="menu-header__text">
            <p className="menu-header__text__title">{metaData.menu.title}</p>
            <p>{metaData.menu.subTitle}</p>
          </div>
        </div>
        <ul>
          {data.map((data_chunk, index) => {
            if (data_chunk.children && !data_chunk.path) {
              // Pass only needed child data onward
              const children = data_chunk.children.map(child => {
                return {
                  path: child.path,
                  title: child.title
                };
              });
              return (
                <MenuSection
                  key={data_chunk.title}
                  title={data_chunk.title}
                  children={children}
                  onClick={() => this.setOpenMenu(data_chunk.title)}
                  open={openMenu === data_chunk.title}
                  currentPage={currentPage}
                  allPathsOn={this.state.allPathsOn}
                  last={this.determineLastSection(index)}
                />
              );
            } else if (data_chunk.path && data_chunk.path !== '/') {
              return (
                <MenuPage
                  key={data_chunk.path}
                  path={data_chunk.path}
                  title={data_chunk.title}
                  currentPage={currentPage}
                  allPathsOn={allPathsOn}
                />
              );
            }

            return null;
          })}
          {/*{process.env.NODE_ENV !== 'production' && (*/}
          {/*<li>*/}
          {/*  <button onClick={this.turnRoutesOn}>*/}
          {/*    Turn All Routes {allPathsOn ? 'Off' : 'On'}*/}
          {/*  </button>*/}
          {/*</li>*/}
          {/*)}*/}
        </ul>
      </div>
    );
  }
}

Menu.propTypes = {
  data: PropTypes.array.isRequired,
  currentPage: PropTypes.string
};

export default Menu;



// WEBPACK FOOTER //
// ../core/src/components/Menu/Menu.js